export default {
    lotteryQr: 'Lottery qr code',
    checkResult: 'Check result must',
    downloadApp: 'Download APP',
    prize: 'Prize',
    introTitle: 'How to conduct a lottery and claim prizes',
    lotteryRule: 'Lottery rule',
    checkDetailsHint: '（Click to view details）',
    addCardHint1: 'Add your ',
    addCardHint2: ' card to Laidan',
    howGetCard: 'How to get your card',
    getCardText: 'You can use this card with the free mobile app, Laidan!',
    flowTitle1: 'Install Laidan',
    flowText1: 'If you don’t have Laidan, you can get it for free and slim down your wallet!',
    flowTitle2: 'Add your card',
    flowText2: 'Once you have Laidan installed, click this button to add the card to the app!',
    flowTitle3: 'All set!',
    flowText3: 'Enjoy your improved mobile shopping experience!',
    flowBtnText1: 'GET IT ON',
    flowBtnText2: 'Download on the',
    flowBtnText3: 'Add to',
    merchantOs: 'Your merchant system',
    howCreateOs: 'How to create your system',
    createOsText: 'You can manage your goods and create VIP system via Joinku free mobile app',
    kuTitle1: 'Download Joinku',
    kuText1: 'If you don\'t have Joinku, you can use it to save time! ',
    kuTitle2: 'View your system',
    kuText2: 'Once Joinku is installed, click this button to view members and orders! ',
    kuTitle3: 'All done! ',
    kuText3: 'Enjoy your best system administration experience! ',
    taxExpert: "Your electronic receipt system",
    howGetTax: 'How to get your electronic receipt',
    getTaxText: 'You can receive your electronic receipts and participate in prize draws via the free Laidan mobile app',
    danTitle1: 'Download Laidan',
    danText1: 'If you don\'t have Laidan, you can use it to receive discounts and promotions! ',
    danTitle2: 'Browse your activities',
    danText2: 'Once Laidan is installed, click this button to participate in your promotion! ',
    danText3: 'Enjoy your best mobile bidding experience! ',
    inviteCashDedu: 'Invite cash deduction',
    inviteCode: 'Invite Code',
    copyInviteCode: 'Click to copy invite code! ',
    copySucceed: 'Copy successful! ',
    copyError: 'Copy failed! ',
    memberSystem: 'VIP system',
    memberSystemText: 'Every time you invite a new user to register as a Joinku user with your invitation code, you can get a deduction of the annual fee of 100€',
    inviteTitle2: 'Set invite code',
    inviteText2: 'Once you have Joinku installed, copy the invite code and click this button to go to Joinku!',
    inviteText3: 'Get a cash deduction of the annual fee! ',
    flowBtnText4: 'Go look',
    phoneLabel: 'Telephone:',
    addressLabel: 'address:',
    readAndAccept: 'read and accept',
    privacyPolicy: 'Privacy Policy',
    startLottery: 'start lottery',
    usePhoneLogin: 'Login with mobile number',
    useEmailLogin: 'Login via email',
    phoneLogin: 'Mobile number login',
    countryCodeSearch: 'Enter country name, area code to search',
    emailLogin: 'Email Login',
    getAuthCode: 'get verification code',
    inpPhoneHint: 'Please enter the phone number',
    inpEmailHint: 'Please enter your email account',
    inpAuthCode: 'please enter verification code',
    codeVerifyTitle: 'Please complete the security check',
    codeVerifyHint: 'Swipe right to complete verification',
    verifyError: 'Validation failed',
    verifyFinish: 'check complete',
    login: 'Log in',
    clickCheck: 'click to see',
    downAppPrize: 'Download the APP to view the prizes',
    lottoErrorHint: 'Wrong lottery code',
    lottoNoloHint: 'Please wait patiently',
    lottoNowiHint: 'sorry not to win',
    lottoWinnHint: 'Congratulations on winning the prize!!!',
    lottoUsedHint: 'This lottery code has already been used',
    partPlatLotto: 'Welcome to participate in the platform lottery',
    skipPlatLotto: 'Then automatically jump to the platform lottery page',
    skipPrize: 'Automatically jump to the prize page',
    allowMerRead: 'Allow merchants to access my information:',
    infoMore: 'name, phone number, birthday',
    joinMember: 'join member',
    checkMember: 'view members',
    drawPlatCoupon: 'Receive platform coupons',
    moreDisDis: 'More discounts',
    firLoginDraw: 'The first time you log in to the APP, you can get',
    clickDown: 'Click to download',
    appDraw: 'APP to receive',
    validTime: 'Valid until',
    useAwaCodeHint: 'Please use it on your next meal and present the barcode at checkout',
    platLottoCode: 'Platform lottery code',
    lottoCode: 'Lucky Draw Code:',
    lotteryTime: 'Draw time: ',
    noLottery: 'Not drawn',
    yetWinning: 'Has won',
    noWinning: 'Didn\'t win',
    haveUsed: 'Used',
    sellOut: 'Sold out',
    currentPrice: 'Set date/time',
    includeAllergen: 'Contains allergens',
    details: 'Details',
    selectAllergen: 'Allergens',
    rawMaterials: 'Ingredients:',
    cookingWay: 'Description:',
    allergens: 'Allergens:',
    mayAddMaterials: 'Add ingredients:',
    mayMinusMaterials: 'Remove ingredients:',
    taste: 'Taste preference:',
    selectedGroupNum: 'Selected dish quantity:',
    priceZero: 'dish priced 0',
    priceNoZero: 'Dishes with a price not equal to 0',
    notSetMealDishes: 'No dishes in this set meal',
    notGroupDishes: 'No dishes in this category',
    notDishesMat: 'No raw materials in this dish',
    notGroupMat: 'No raw materials in this category',
    selectFinish: 'Selected',
    noSelectFinish: 'To select',
    cancel: 'Cancel',
    woka: {
        activityPage: 'Event Page',
        unlockDish: 'Unlock Dishes for Free',
        unlockText: 'Participate in the sharing event according to the rules to unlock any dish for free!',
        activityRule: 'Event Rules',
        ruleText: 'Choose one of the following methods, upload a screenshot to the designated location, and receive a dish redemption code.',
        issueWork: 'Post Content',
        weChat: 'WeChat',
        wechatText: 'Share to your Moments and collect 20 likes from friends.',
        douyinText1: '1. Join the topic #AICookingAssistant#',
        douyinText2: '2. Pinned Comment',
        douyinText3: '3. Post on TikTok @xxxx',
        redBook: 'Xiaohongshu',
        redBookText2: '2. Tag your location',
        instagramText1: '1. Post a public Story + post/Reels',
        instagramText2: '2. @Mention 3 friends',
        tikTokText1: '1. Temporary Story',
        tikTokText2: '2. Public post @mention 3 friends',
        partActivity: 'Join the event',
}
};
